import { HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GeneratePartnerRequestKeyUseCaseInterface } from 'domain/usecases';

export class RemoteGeneratePartnerRequestKey implements GeneratePartnerRequestKeyUseCaseInterface {
  constructor(
    private readonly baseUrl: string,
    private readonly httpClient,
  ) {}

  async execute(params: { id: number }): Promise<GeneratePartnerRequestKeyUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      url: `${this.baseUrl}/${params.id}/api-key`,
      method: 'patch',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body?.message);
    }
  }
}
